// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2FCgH","dragIcon":"SortableItem_dragIcon__18u-e","disabled":"SortableItem_disabled__30cFJ"};